export enum HHDSSelectState {    
    Default = 'default',
    Error = 'error',
}